import { buildQueryString, fetchWrapper } from '@/_helpers';

const CALL_CENTER_TEAM_SETTINGS_BASE_PATH = 'call-center/team-settings';

export const callCenterTeamSettingsApi = {
    getSettings: (teamId) => fetchWrapper.get(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}`),
    updateSettings: (teamId, data) => fetchWrapper.patch(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}`, data),
    setupTeamCalling: (teamId) => fetchWrapper.post(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}/setup`),
    getAvailableNumbers: ({ team: teamId, areaCode, countryCode = 'US' } = {}) => {
        const queryString = buildQueryString({ areaCode, countryCode });
        return fetchWrapper.get(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}/available-numbers?${queryString}`);
    },
    provisionNumber: (teamId, data) =>
        fetchWrapper.post(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}/provision-number`, data),
    getElevenLabsVoices: (teamId) => fetchWrapper.get(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}/ivr/voices`),
    regenerateIvrPromptAudio: (teamId, data) =>
        fetchWrapper.post(`${CALL_CENTER_TEAM_SETTINGS_BASE_PATH}/${teamId}/ivr/prompt-audio/regenerate`, data),
};
